export default __webpack_public_path__ + "static/media/instagram.96072927.svg";